import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TransportCreationProfileSight } from '../../cep-tablet.model';

@Component({
  selector: 'app-cep-profile-tile',
  templateUrl: './cep-profile-tile.component.html',
  styleUrls: ['./cep-profile-tile.component.scss']
})
export class CEPProfileTileComponent {

  @Input()
  profile: TransportCreationProfileSight;


}
